import React, { FC, HTMLAttributes } from "react";

interface Props {
  showSummaryDetails?: any;
  summaryType?: string;
  showFilterResults?: boolean;
  summaryDetailsResponse?: boolean;
}

const ZeroScreen: FC<Props> = ({
  showSummaryDetails,
  summaryType,
  showFilterResults,
  summaryDetailsResponse,
}: Props) => {
  return (
    <div
      className={`flex flex-col items-center justify-center smd:mt-0 h-[80vh] ${
        showSummaryDetails ? "h-[80vh]" : ""
      } bg-white mx-auto`}
    >
      <span className="rista-sprite ic-summary-blue bg-[#E4F1FF] p-[10px] !border !rounded-[50%] overflow-hidden"></span>
      <p className="mt-13 font-[20px] font-semibold text-[#395E88] text-16">
        {summaryDetailsResponse ? (
          <p className="items-center flex justify-center m-[10%]">
            You are not allowed to view the sales summary. Please contact your
            administrator.
          </p>
        ) : (
          <>
            {showFilterResults ? (<p>
              No data found. Please try another date or filters</p>
            ) : (
              <>
                {!showSummaryDetails && !summaryType
                  ? <p>Select Date, Branch, Brand, and to view summary</p>
                  : <p>{`Your ${summaryType} summary will appear here`}</p>}

                {showSummaryDetails && (
                  <p className="text-[#395E88] text-14 mt-12 font-normal items-center flex justify-center">
                    Please select a value from the list
                  </p>
                )}
              </>
            )}
          </>
        )}
      </p>
    </div>
  );
};

export default ZeroScreen;
